import { DialogStore } from "@ariakit/react";
import { ReactNode } from "react";
import { ModalDialog } from "../modal-dialog";
import * as css from "./style.css";

export function InfoDialog(props: { children: ReactNode; store?: DialogStore }) {
  return (
    <ModalDialog store={props.store} className={css.dialog}>
      <div className={css.inner}>{props.children}</div>
    </ModalDialog>
  );
}
